export default __webpack_public_path__ + "static/media/request.360256a0.png";